import { AuthChangePerspectiveAction } from "./actions/AuthChangePerspective";
import { AuthCompleteEmailVerificationAction, AuthCompleteEmailVerificationEndAction } from "./actions/AuthCompleteEmailVerification";
import { AuthLoginFailureAction, AuthLoginRequestAction, AuthLoginSuccessAction } from "./actions/AuthLogin";
import { AuthLogoutRequestAction } from "./actions/AuthLogout";
import { AuthRenewSessionAction } from "./actions/AuthRenewSession";
import { AuthResendVerificationEmailAction, AuthResendVerificationEmailEndAction } from "./actions/AuthResendVerificationEmail";
import { AuthSetProfileAction } from "./actions/AuthSetProfile";
import { AuthSetTokenAction } from "./actions/AuthSetToken";
import { AuthUnlinkRequestAction } from "./actions/AuthUnlink";

export type AuthActions =
    | AuthChangePerspectiveAction
    | AuthLoginRequestAction
    | AuthLoginSuccessAction
    | AuthLoginFailureAction
    | AuthLogoutRequestAction
    | AuthRenewSessionAction
    | AuthResendVerificationEmailAction
    | AuthResendVerificationEmailEndAction
    | AuthUnlinkRequestAction
    | AuthCompleteEmailVerificationAction
    | AuthCompleteEmailVerificationEndAction
    | AuthSetTokenAction
    | AuthSetProfileAction;

export * from "./actions/AuthChangePerspective";
export * from "./actions/AuthCompleteEmailVerification";
export * from "./actions/AuthLogin";
export * from "./actions/AuthLogout";
export * from "./actions/AuthRenewSession";
export * from "./actions/AuthResendVerificationEmail";
export * from "./actions/AuthSetToken";
export * from "./actions/AuthUnlink";
export * from "./actions/AuthSetProfile";